import { render } from "./TazeVaredin.vue?vue&type=template&id=798b3558&scoped=true"
import script from "./TazeVaredin.vue?vue&type=script&lang=js"
export * from "./TazeVaredin.vue?vue&type=script&lang=js"

import "./TazeVaredin.vue?vue&type=style&index=0&id=798b3558&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798b3558"]])

export default __exports__